<template>
    <div class="row">
        <div class="col-md-4">
            <div class="rounded p-4 bg-white shadow-sm mb-2">
                <auth v-if="user" :user="user"></auth>
            </div>
        </div>
        <div class="col-md-8">
            <div class="rounded p-4 bg-white shadow-sm" style="min-height: 500px">
            </div>
        </div>
    </div>
</template>

<script>
import Auth from "./Auth";

export default {
    name: "Staff",
    components: {Auth},
    props: ['id'],
    data() {
        return {
            user: {}
        }
    },
    mounted() {
        this.$http.get(`staff/${this.id}`).then(response => {
            this.user = response.data.data
        })
    }
}
</script>

<style scoped>

</style>